import React, { useState, useEffect } from "react";
import "./RatingStar.css";

const RatingStar = ({ disabled = false, value = 0, onChange }) => {
  const [selectedRating, setSelectedRating] = useState(value);
  const [hoverRating, setHoverRating] = useState(0);
  const [activePressed, setActivePressed] = useState(null);

  useEffect(() => {
    setSelectedRating(value);
  }, [value]);

  const handleMouseDown = (index) => {
    if (disabled) return;
    setActivePressed(index);
  };

  const handleMouseUp = (index) => {
    if (disabled) return;
    const newRating = index + 1;
    setSelectedRating(newRating);
    setActivePressed(null);
    if (onChange) {
      onChange(newRating);
    }
  };

  const handleMouseEnter = (index) => {
    if (disabled) return;
    setHoverRating(index + 1);
  };

  const handleMouseLeave = () => {
    if (disabled) return;
    setHoverRating(0);
    setActivePressed(null);
  };

  return (
    <div className={`rating ${disabled ? "disabled" : ""}`}>
      {[...Array(5)].map((_, index) => {
        const isFilled = hoverRating
          ? index + 1 <= hoverRating
          : index + 1 <= selectedRating;

        return (
          <span
            key={index}
            className={`star 
              ${isFilled ? "selected" : ""} 
              ${index === activePressed ? "pressed" : ""}`}
            onMouseDown={() => handleMouseDown(index)}
            onMouseUp={() => handleMouseUp(index)}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            style={{ cursor: disabled ? "not-allowed" : "pointer" }}
          ></span>
        );
      })}
    </div>
  );
};

export default RatingStar;

